import { Invitation } from '@playcastdotio/Messaging';
import { makeStateStore } from '@playcastdotio/StateStore';

export const invitationStore = makeStateStore<Invitation | null>(null);
